export const homeCardGroups = [
    { id: "customization", name: "Personalización", icon: "🎨" },
    { id: "orders", name: "Ventas", icon: "💳" },
    { id: "products", name: "Productos", icon: "🛍️" },
    { id: "inventories", name: "Inventario", icon: "🧮" },
    { id: "cart", name: "Carros de compras", icon: "🛒" },
    { id: "stores", name: "Tiendas", icon: "🏪" },
    { id: "customers", name: "Clientes", icon: "👩" },
    { id: "brands", name: "Marcas", icon: "🔖" },
    { id: "collections", name: "Colecciones", icon: "🏷️" },
    { id: "lines", name: "Categorías", icon: "➖" },
    { id: "suppliers", name: "Proveedores", icon: "🏭" },
    { id: "warehouses", name: "Bodegas", icon: "🏬" },
    { id: "cashOutputs", name: "Gastos", icon: "💸" },
    { id: "supplyLists", name: "Listas de compras", icon: "📜" },
    { id: "users", name: "Usuarios y roles", icon: "👩‍💻" },
    { id: "merchantOperations", name: "Operación de tienda", icon: "👩‍🏭" },
    { id: "files", name: "Archivos e imágenes", icon: "🖼️" },
    { id: "settings", name: "Configuración", icon: "⚙️" },
    { id: "tenants", name: "Tenants", icon: "🏢" },
    {
        id: "shared_images",
        name: "Banco de imágenes compartidas",
        icon: "🖼️"
    },
    { id: "other", name: "Otros", icon: "🧩" }
];

export const getHomeCardGroup = (groupId) =>
    homeCardGroups.find((group) => group.id === groupId) ||
    homeCardGroups.find((group) => group.id === "other");
